const SHARE_HASH_PREFIX = '#s=';

function toBase64Url(bytes: Uint8Array): string {
    let binary = '';
    bytes.forEach(b => {
        binary += String.fromCharCode(b);
    });
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function fromBase64Url(str: string): Uint8Array {
    const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
    const binary = atob(padded);
    return Uint8Array.from(binary, c => c.charCodeAt(0));
}

export function encodeShareState(payload: unknown): string {
    const json = JSON.stringify(payload);
    return toBase64Url(new TextEncoder().encode(json));
}

export function decodeShareState<T>(encoded: string): T | null {
    try {
        const json = new TextDecoder().decode(fromBase64Url(encoded));
        return JSON.parse(json) as T;
    } catch {
        return null;
    }
}

export function buildShareUrl(payload: unknown): string {
    const {origin, pathname} = window.location;
    return `${origin}${pathname}${SHARE_HASH_PREFIX}${encodeShareState(payload)}`;
}

export function hasShareHash(): boolean {
    return window.location.hash.startsWith(SHARE_HASH_PREFIX);
}

export function readShareHash<T>(): T | null {
    if (!hasShareHash()) return null;
    return decodeShareState<T>(window.location.hash.slice(SHARE_HASH_PREFIX.length));
}
